import { render, staticRenderFns } from "./cart-page.vue?vue&type=template&id=081171b1&scoped=true"
import script from "./cart-page.vue?vue&type=script&lang=js"
export * from "./cart-page.vue?vue&type=script&lang=js"
import style0 from "./cart-page.vue?vue&type=style&index=0&id=081171b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081171b1",
  null
  
)

export default component.exports